import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import ViewMoreBtn from "../../components/ViewMoreBtn";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { arrowRight } from "../../../../assets/svg/Svg";
import { LuFilter } from "react-icons/lu";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getVouchers } from "../../../../redux/slices/voucherSlice";
import { AiOutlineDelete } from "react-icons/ai";
import { FiEdit } from "react-icons/fi";
import { getTips } from "../../../../redux/slices/tipSlice";

const Tip = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [category, setCategory] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const { tips, refetch } = useSelector((state) => state.tipSlice);

  const prevProps = useRef({ refetch }).current;

  useEffect(() => {
    if (prevProps.refetch != refetch) {
      dispatch(getTips(setIsLoading));
    }
    return () => {
      prevProps.refetch = refetch;
    };
  }, [refetch]);

  useEffect(() => {
    setIsLoading(true);
    dispatch(getTips(setIsLoading));
  }, []);

  const columns = [
    {
      name: "Created At",
      selector: (row) => row.createdAt,
      sortable: true,
    },
    {
      name: "Tip Amount",
      selector: (row) => row.tipAmount,
      sortable: true,
    },
    {
      name: "User",
      selector: (row) => row.user,
      sortable: true,
    },
    {
      name: "Trainer",
      selector: (row) => row.trainer,
      sortable: true,
    },
    {
      name: "Order-Id",
      selector: (row) => row.orderId,
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
    },
    {
      name: "Actions",
      selector: (row) => row.action,
    },
  ];

  const data = tips.map((tip) => {
    const isDeleted = tip.deleted;

    const iconStyle = {
      minWidth: "max-content",
      cursor: isDeleted ? "not-allowed" : "pointer",
      opacity: isDeleted ? 0.5 : 1,
    };

    return {
      id: 0,
      tipAmount: `$ ${tip?.tipAmount}`,
      user: (
        <span
          style={{ color: "#be9528", cursor: "pointer" }}
          onClick={() => navigate(`/user/${tip?.createdByDetails?.[0]?._id}`)}
        >
          {tip?.createdByDetails?.[0]?.fullName}
        </span>
      ),
      trainer: (
        <span
          style={{ color: "#be9528", cursor: "pointer" }}
          onClick={() => navigate(`/trainer/${tip?.trainerDetails?.[0]?._id}`)}
        >
          {tip?.trainerDetails?.[0]?.fullName}
        </span>
      ),
      orderId: (
        <span
          style={{ color: "#be9528", cursor: "pointer" }}
          onClick={() => navigate(`/order/${tip?.orderId}`)}
        >
          {tip?.orderId}
        </span>
      ),
      status: (
        <label
          className={
            tip?.active == false ? "badge badge-danger" : "badge badge-success"
          }
        >
          {tip?.active == false ? "Inactive" : "Active"}
        </label>
      ),
      createdAt: new Date(tip.createdAt)
        .toLocaleDateString("en-US", {
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
        })
        .replace(/\//g, "-"),
      action: (
        <div className="d-flex">
          <AiOutlineDelete
            size={19}
            onClick={
              !isDeleted
                ? () => {
                    setDeleteId(tip?._id);
                    setDeleteModal(true);
                  }
                : null
            }
            style={iconStyle}
          />
        </div>
      ),
    };
  });

  const filteredData = data.filter((item) => {
    const name =
      typeof item?.user === "string" ? item?.user?.toLowerCase() : "";

    return (
      name.includes(searchText.toLowerCase()) &&
      (category ? item.status.props.children === category : true)
    );
  });

  const handleSearch = (value) => {
    setSearchText(value);
    setResetPaginationToggle(!resetPaginationToggle);
  };

  const handleCategoryChange = (value) => {
    setCategory(value);
    setResetPaginationToggle(!resetPaginationToggle);
  };

  return (
    <>
      {isLoading ? (
        <div className="w-100 d-flex">
          <div class="spinner-border text-primary mx-auto" role="status"></div>
        </div>
      ) : (
        <>
          <div>
            <div className="page-header">
              <h3 className="page-title">Tips</h3>
            </div>
            <div className="row">
              <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body py-4">
                    <>
                      {/* <button onClick={handleClearRows}>Clear Selected Rows</button> */}
                      <DataTable
                        // title={<h6 className="card-title">Users List</h6>}
                        columns={columns}
                        data={filteredData}
                        pagination
                        paginationPerPage={10}
                        paginationRowsPerPageOptions={[
                          10, 20, 30, 50, 100, 200, 500,
                        ]}
                        // paginationComponent={customPagination}
                        highlightOnHover
                        pointerOnHover
                        subHeader
                        subHeaderAlign="left"
                        subHeaderComponent={
                          <>
                            <Row className="mb-3 w-100">
                              <Col
                                md={8}
                                className="d-flex align-items-start flex-column gap-2"
                              >
                                <span className="d-flex align-items-center gap-2 me-3 filterby_label">
                                  <LuFilter />
                                  Filter By :
                                </span>
                                <div className="table_filter">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search by name"
                                    value={searchText}
                                    onChange={(e) =>
                                      handleSearch(e.target.value)
                                    }
                                  />
                                  <select
                                    className="form-control h-54px w-auto"
                                    value={category}
                                    onChange={(e) =>
                                      handleCategoryChange(e.target.value)
                                    }
                                  >
                                    <option selected value="">
                                      Status
                                    </option>
                                    <option value="Active">Active</option>
                                    <option value="Inactive">Inactive</option>
                                  </select>
                                </div>
                              </Col>
                            </Row>
                          </>
                        }
                      />
                    </>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Tip;
